import React from "react";
import Button from "../../shared/component/button/Button";
import { Icon } from "react-materialize";
import {
  getNotifications,
  resetNotifications
} from "../../redux/notification/notifications.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getInvites } from "../../redux/providerSelected/providersSelected.action";
import moment from "moment";
import {
  resetServiceOrder,
  getById
} from "../../redux/serviceOrder/serviceOrder.action";

import "./Notifications.css";
import { get } from "../../shared/infra/http/AxiosConfig";

const dateFormat = date =>
  date ? moment(date).format("DD/MM/YYYY HH:mm") : "-";

class Notifications extends React.Component {
  state = {};

  openNav = () => {
    document.getElementById("mySidenav").style.width = "594px";
    document.getElementsByClassName("footer-nav")[0].style.width = "594px";
    document.getElementsByClassName("menu-overlay")[0].style.width = "100%";
    document.getElementsByClassName("menu-overlay")[0].style.opacity = 1;
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";

    this.props.getNotifications();
  };

  closeNav = () => {
    document.getElementById("mySidenav").style.width = "0px";
    document.getElementsByClassName("footer-nav")[0].style.width = "0px";
    document.getElementsByClassName("menu-overlay")[0].style.width = "0px";
    document.getElementsByClassName("menu-overlay")[0].style.opacity = 0;
    document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    this.props.resetNotifications();
  };

  openOS = async notification => {
    this.closeNav();
    await this.props.getInvites(notification.orderServiceId);
    await this.props.getById(notification.orderServiceId);
    this.props.history.push(`/orderservice/${notification.orderServiceId}`);
  };

  render() {
    const { notifications } = this.props;
    return (
      <React.Fragment>
        <div className="menu-overlay"></div>
        <div id="mySidenav" className="sidenav">
          <div>
            <span className="title">Notificações</span>
          </div>
          <div style={{ marginTop: 10, marginBottom: 80 }}>
            {notifications &&
              notifications.map((notificate, idx) => (
                <div
                  key={idx}
                  className="item-notification"
                  onClick={() => this.openOS(notificate)}
                >
                  <div className="item">
                    <span className="font-bold">
                      {notificate.status}
                      <span className="font-regular">
                        {" "}
                        por {notificate.email}
                      </span>
                    </span>

                    <span className="font-bold">
                      Cliente:
                      <span className="font-regular">
                        {" "}
                        {notificate.customer}
                      </span>
                    </span>
                  </div>
                  <div className="item2">
                    <span className="font-regular">
                      {dateFormat(notificate.createDate)}
                    </span>
                    <span className="font-bold">#{notificate.protocol}</span>
                  </div>
                </div>
              ))}
          </div>
          <div className="footer-nav">
            <div className="button-footer">
              <Button
                classButton="btn-pendente"
                label={"Fechar"}
                handleClick={() => this.closeNav()}
              />
            </div>
          </div>
        </div>

        <div>
          <span onClick={() => this.openNav()}>
            <Icon className="icon-notification">notifications</Icon>
          </span>
        </div>
      </React.Fragment>
    );
  }
}

const mapActionToProps = dispatch =>
  bindActionCreators(
    {
      getNotifications: getNotifications,
      getInvites: getInvites,
      resetServiceOrder: resetServiceOrder,
      resetNotifications: resetNotifications,
      getById: getById
    },
    dispatch
  );

const mapStateToProps = state => ({
  notifications: state.notifications
});

Notifications = connect(mapStateToProps, mapActionToProps)(Notifications);

export default Notifications;



// WEBPACK FOOTER //
// ./src/pages/notification/Notifications.jsx